// extracted by mini-css-extract-plugin
module.exports = {"highways":"a10a3f92e9--highways--CfZhE"};